<template>
  <div>
    <h1>New order<span v-if="cloneSourceId" class="text-muted" style="font-size: 0.6em;"> (clone of #{{ cloneSourceId }})</span></h1>
    <LoadingIndicator v-if="cloneLoading" centered />
    <template v-else>
      <ValidationObserver ref="observer">
        <form @submit.prevent="submit()">
          <FormFieldsLead
            :form-fields="form"
            :errors="errors"
            @input="handleFormInput"
            render-pricing-form
            render-pickup-contact-form
            render-delivery-contact-form
            render-shipping-form
            :show-customer-search="true"
          />
          <button :disabled="submitDisabled" class="btn btn-primary" type="submit">Save</button>
        </form>
      </ValidationObserver>
      <BottomPanel :form-fields="form" />
    </template>
  </div>
</template>

<script>
import FormFieldsLead from '@/components/shared/formFields/FormFieldsLead';
import { ApiClient } from '@/api/ApiClient';
import BottomPanel from "@/components/shared/BottomPanel.vue";
import LoadingIndicator from '@/components/shared/LoadingIndicator.vue';

export default {
  name: 'OrderNew',
  components: { FormFieldsLead, BottomPanel, LoadingIndicator },
  data() {
    return {
      errors: {},
      customers: [],
      cloneSourceId: null,
      cloneLoading: false,
      form: {
        customer: {
          contact: {},
        },
        vehicles: [{}],
        pickupLocation: {},
        pickupContact: {},
        deliveryLocation: {},
        deliveryContact: {},
        sourceId: null,
      },
      submitDisabled: false,
    };
  },
  async created() {
    const cloneId = this.$route.query.clone;
    if (cloneId) {
      this.cloneSourceId = cloneId;
      this.cloneLoading = true;
      await this.loadClone(cloneId);
      this.cloneLoading = false;
    }
  },
  methods: {
    async loadClone(id) {
      const response = await ApiClient.leads.get({ id });
      if (response.status === 200) {
        const lead = response.data.data;
        const stripId = (obj) => { const copy = { ...obj }; delete copy.id; return copy; };
        this.form = {
          customer: lead.customer,
          vehicles: lead.vehicles.map((v) => { const copy = { ...v }; delete copy.id; delete copy.leadId; return copy; }),
          pickupLocation: stripId(lead.pickupLocation),
          pickupContact: lead.pickupContact ? stripId(lead.pickupContact) : {},
          deliveryLocation: stripId(lead.deliveryLocation),
          deliveryContact: lead.deliveryContact ? stripId(lead.deliveryContact) : {},
          transportTypeId: lead.transportTypeId,
          sourceId: lead.sourceId,
          shipperNotes: lead.shipperNotes,
          shipperInformation: lead.shipperInformation,
          auctionBuyerNumber: lead.auctionBuyerNumber,
          moveDate: lead.moveDate,
          moveDateLast: lead.moveDateLast,
          carrierPay: lead.carrierPay,
          balanceMethodId: lead.balanceMethodId,
          balanceCodcopMethodId: lead.balanceCodcopMethodId,
          disableProcessingFee: lead.disableProcessingFee,
          userId: lead.userId,
        };
      }
    },
    handleFormInput(newForm) {
      this.form = newForm;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.save();
      } else {
        this.handleSendErrorToast({ message: 'Required field(s) missing.' });
      }
    },
    async save() {
      if (this.submitDisabled) return;
      this.submitDisabled = true;
      const body = Object.assign({}, this.form, { lead_type_id: 3, lead_status_id: 3 });
      const response = await ApiClient.leads.post({ body });
      this.submitDisabled = false;
      if (response.status === 200) {
        this.errors = {};
        const newOrder = response.data.data;
        this.$router.push({ name: 'OrderDetails', params: { id: newOrder.id } });
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      }
    },
    handleSendErrorToast({ message }) {
      this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
